'use client';

import dynamic from 'next/dynamic';

export const WhistleblowerFormStrapi = dynamic(() =>
  import('./WhistleblowerFormStrapi').then((m) => m.WhistleblowerFormStrapi)
);
